// The workspace the list and import calls should name: the switcher's choice for a person who holds
// several, nothing for a person who holds one or while the access answer is not ready.
import { useAuth } from '@/hooks/useAuth'
import { workspaceToSend } from '@/hooks/access-model'

export function useSelectedWorkspace() {
  const { access } = useAuth()
  return workspaceToSend(access)
}
